import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { History } from 'lucide-react';
import type { EventLogEntry } from '@container-system/shared';
import { listEvents } from '../../api/events';
import { Card, CardBody, CardHeader, CardTitle } from '../../components/ui/Card';
import { DataTable, Pagination, type Column } from '../../components/ui/DataTable';
import { PageHeader } from '../../components/ui/PageHeader';
import { FullPageSpinner } from '../../components/ui/Spinner';
import { formatDateTime } from '../../utils/format';

export function EventsPage() {
  const [page, setPage] = useState(1);
  const query = useQuery({ queryKey: ['events', page], queryFn: () => listEvents({ page, pageSize: 50 }) });

  const columns: Column<EventLogEntry>[] = [
    { key: 'createdAt', header: 'Zeitpunkt', render: (e) => formatDateTime(e.createdAt) },
    { key: 'username', header: 'Benutzer', render: (e) => e.username },
    { key: 'action', header: 'Aktion', render: (e) => <code className="rounded bg-surface-700 px-1.5 py-0.5 text-xs text-accent-300">{e.action}</code> },
    { key: 'details', header: 'Details', render: (e) => e.details ?? '—' },
  ];

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Audit-Log" />
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-1.5">
            <History className="h-4 w-4 text-accent-400" strokeWidth={1.75} /> Alle Ereignisse
          </CardTitle>
        </CardHeader>
        <CardBody>
          {query.isLoading ? (
            <FullPageSpinner />
          ) : (
            <>
              <DataTable columns={columns} rows={query.data?.items ?? []} rowKey={(e) => e.id} />
              <Pagination page={page} totalPages={query.data?.totalPages ?? 1} onChange={setPage} />
            </>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
